/** Presentation helpers for the 1–5 "Scholarship $" rating computed in the data pipeline
 *  (scripts/lib/scholarship.mjs). The rating is athletic scholarship money only — a 1
 *  means "no athletic aid; academic / need-based only" (DIII, Ivy, service academies). */

export const DOLLAR_MAX = 5;

export const DOLLAR_LABEL: Record<number, string> = {
  0: "No athletic scholarships (academic / need-based aid only)",
  1: "Minimal athletic money",
  2: "Limited athletic money",
  3: "Partial scholarships likely",
  4: "Strong scholarship potential",
  5: "Top-tier scholarship budget",
};

/** e.g. 3 -> "$$$" (filled) plus what the component draws as faded remainder. */
export function dollarSigns(n: number | null | undefined): string {
  if (!n || n < 1) return "";
  return "$".repeat(Math.min(DOLLAR_MAX, n));
}
